module.exports = __webpack_public_path__ + "assets/img/gaoji.29be8a46.png";